import React from "react";
import { ButtonProps as MUIButtonProps } from "@mui/material";
import { CircularProgress } from "@mui/material";
import { CustomButtonStyled } from "./CustomButton.Styled";

export interface CustomButtonProps extends MUIButtonProps {
  isLoading?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  isLoading = false,
  startIcon,
  endIcon,
  disabled,
  ...rest
}) => {
  return (
    <CustomButtonStyled
      {...rest}
      startIcon={!isLoading ? startIcon : null}
      endIcon={!isLoading ? endIcon : null}
      disabled={disabled || isLoading}
    >
      {isLoading ? <CircularProgress size={24} color="inherit" /> : children}
    </CustomButtonStyled>
  );
};

export default CustomButton;
